import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { IsLoginState } from "../../../state/user-session";
import GoogleLoginBtn from "../../../components/login-btn/google";
import KakaoLoginBtn from "../../../components/login-btn/kakao";
import NaverLoginBtn from "../../../components/login-btn/naver";
import Footer from "../../../components/footer";

export const LoginReason = {
    CARD_REGISTER: "CARD_REGISTER",
    PROFILE_DRAFTED: "PROFILE_NEED_UPDATE"
}


function LoginPage() {
    const [isLoading, isLogin] = useRecoilValue(IsLoginState)
    const { state } = useLocation()
    const navigate = useNavigate()
    const [metaInfo, setMetaInfo] = useState({})

    const directUrlHandler = () => {
        if (isLogin) {
            navigate(-1)
        } else {
            setMetaInfo({ redirectUrl: "/" })
        }
    }

    const redirectUrlHandler = () => {
        const reason = state.reason;
        if (reason === LoginReason.CARD_REGISTER) {
            setMetaInfo({
                reason: reason,
                cardUuid: state.cardUuid
            })
        } else if (reason === LoginReason.PROFILE_DRAFTED) {
            setMetaInfo({
                reason: reason,
                profileLink: state.profileLink
            })
        } else {
            throw new Error("Unexpected login path")
        }
    }

    useEffect(() => {
        if (isLoading) {
            return
        }

        const isAccessingByDirectUrl = state == null;
        if (isAccessingByDirectUrl) {
            directUrlHandler()
        } else {
            redirectUrlHandler()
        }
    }, [isLoading])

    if (isLoading) {
        return <></>
    }

    return (
        <div className="Layer login">
            <div className="main-image-container">
                <video src='/assets/img/main_video.mp4' typeof='video/mp4' loop playsInline muted autoPlay></video>
            </div>
            <div classsName="Layer-inner">
                <div className="login-btn-container">
                    <p className="login-desc">다음 계정으로 로그인</p>
                    <div className="login-btn-wrapper">
                        <GoogleLoginBtn metaInfo={metaInfo} />
                        <KakaoLoginBtn metaInfo={metaInfo} />
                        <NaverLoginBtn metaInfo={metaInfo} />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default LoginPage;
